module.exports = __webpack_public_path__ + "img/print_shipped.9edbc995.png";